import { render } from "./SampleSleepChart.vue?vue&type=template&id=ab8f520c&scoped=true"
import script from "./SampleSleepChart.vue?vue&type=script&lang=js"
export * from "./SampleSleepChart.vue?vue&type=script&lang=js"

import "./SampleSleepChart.vue?vue&type=style&index=0&id=ab8f520c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8f520c"]])

export default __exports__